<template>
  <section id="home">
    <header :class="{menuOpen: menuOpen, menuAnimate: menuAnimate, scrolled}">
      <div class="headerBg"></div>
      <div class="container">
        <router-link to="/" class="logoLink">
          <div class="logo"></div>
          <div class="logo white"></div>
        </router-link>
        <div class="menu">
          <div class="closeMenu" v-on:click="toggleMenu"></div>
          <router-link class="menuItem menuHome" to="/">Home</router-link>
          <div class="menuItem hasSubmenu" v-on:click="showSubmenu = !showSubmenu">Bumi Kini
            <div class="submenuOverlay" v-if="showSubmenu"
              v-on:click.stop="showSubmenu = false"></div>
            <div class="submenu" v-on:click.stop="doNothing" v-if="showSubmenu">
              <router-link to="/bumi-kini/bumi-dan-krisis-iklim">Bumi dan Krisis Iklim</router-link>
              <router-link to="/bumi-kini/faktor-faktor">Faktor-faktor</router-link>
              <router-link to="/bumi-kini/dampak-yang-mengancam">Dampak yang mengancam</router-link>
              <router-link to="/bumi-kini/upaya-demi-upaya">Upaya demi Upaya</router-link>
            </div>
          </div>
          <div class="menuItem hasSubmenu" v-on:click="showSubmenu2 = !showSubmenu2">Bicara Bumi
            <div class="submenuOverlay" v-if="showSubmenu2"
              v-on:click.stop="showSubmenu2 = false"></div>
            <div class="submenu" v-on:click.stop="doNothing" v-if="showSubmenu2">
              <router-link to="/bicara-bumi/kabar-terkini">Kabar Terkini</router-link>
              <router-link to="/bicara-bumi/seputar-iklim">Seputar Iklim</router-link>
              <router-link to="/bicara-bumi/pesan-dan-kreasi">Pesan dan Kreasi</router-link>
            </div>
          </div>
          <!-- <router-link class="menuItem" to="/bicara-bumi">Bicara Bumi</router-link> -->
          <router-link class="menuItem" to="/sumber-dan-materi">Sumber dan Materi</router-link>
          <!-- <router-link to="/bicara-bumi">Jejaring</router-link> -->
          <router-link class="menuItem" to="/beraksi">Beraksi</router-link>
          <!-- <router-link to="/#">Curhat Iklim</router-link> -->
          <div class="loginBtn" v-on:click="$emit('login')" v-if="!$session.get('jwt')">Masuk</div>
          <div class="userPict" v-else v-on:click.stop="doNothing">
            <div :class="{headerPict: 1, hasPhoto: $session.get('avatar')}"
              :style="{'background-image': `url(${$session.get('avatar')})`}"
              v-on:click.stop="showMenu = true">
              <span>{{$session.get('name').substr(0,2)}}</span>
            </div>
            <div class="userMenuOverlay" v-if="showMenu" v-on:click.stop="showMenu = false"></div>
            <div class="userMenu" v-if="showMenu">
              <div class="pictCnt">
                <div :class="{thePict: 1, hasPhoto: $session.get('avatar')}"
                  :style="{'background-image': `url(${$session.get('avatar')})`}">
                  <span>{{$session.get('name').substr(0,2)}}</span>
                </div>
              </div>
              <h4>{{$session.get('name')}}</h4>
              <h5>{{$session.get('email')}}</h5>
              <!-- <div class="divider"></div> -->
              <!-- <li v-on:click="accountSetting">Pengaturan Akun</li> -->
              <!-- <li v-on:click="pesanKreasi">Pesan dan Kreasi Saya</li> -->
              <div class="divider"></div>
              <li v-on:click.stop="signOut">Keluar</li>
            </div>
          </div>
        </div>
        <div class="menuOverlay" v-on:click="toggleMenu"></div>
        <div class="menuToggle" v-on:click="toggleMenu"></div>
        <div class="loginForMobile">
          <div class="loginBtn" v-on:click="$emit('login')" v-if="!$session.get('jwt')">Masuk</div>
            <div class="userPict" v-else v-on:click.stop="doNothing">
              <div :class="{headerPict: 1, hasPhoto: $session.get('avatar')}"
                :style="{'background-image': `url(${$session.get('avatar')})`}"
                v-on:click.stop="showMenu = true">
                <span>{{$session.get('name').substr(0,2)}}</span>
              </div>
              <div class="userMenuOverlay" v-if="showMenu" v-on:click.stop="showMenu = false"></div>
              <div class="userMenu" v-if="showMenu">
                <div class="pictAndName">
                  <div class="pictCnt">
                    <div :class="{thePict: 1, hasPhoto: $session.get('avatar')}"
                      :style="{'background-image': `url(${$session.get('avatar')})`}">
                      <span>{{$session.get('name').substr(0,2)}}</span>
                    </div>
                  </div>
                  <h4>{{$session.get('name')}}</h4>
                  <h5>{{$session.get('email')}}</h5>
                </div>
                <!-- <div class="divider"></div> -->
                <!-- <li v-on:click="accountSetting">Pengaturan Akun</li> -->
                <!-- <li v-on:click="pesanKreasi">Pesan dan Kreasi Saya</li> -->
                <div class="divider"></div>
                <li v-on:click.stop="signOut">Keluar</li>
              </div>
            </div>
          </div>
      </div>
    </header>

    <div class="welcomeBg">
      <transition-group name="fade" tag="div" class="sliderCnt">
        <div v-for="i in [currentIndex]" :key="i">
          <div v-bind:class="{sliderItem: true}"
            v-bind:style="{ backgroundImage: `url(${currentImg})` }"></div>
        </div>
      </transition-group>
      <div class="bgDivider"></div>
    </div>
    <div class="welcome">
      <div v-bind:class="{welcomeCnt: true, active: i === currentIndex}"
        v-for="(c, i) in sliderContent" :key="i">
        <h2 v-if="c.title">{{c.title}}</h2>
        <p v-if="c.description">{{c.description}}</p>
        <div class="btn" v-on:click="btnClicked(c, i)" v-if="c.buttonLabel">
          <div class="btnL"></div>
          <div class="btnL2"></div>
          <span>{{c.buttonLabel}}</span>
        </div>
      </div>
      <div class="welcomePaging">
        <div class="pItem pLeft" v-on:click="prev"></div>
        <div class="pItem pRight" v-on:click="next"></div>
      </div>
      <div class="welcomePager">
        <div v-bind:class="{pager: true, active: (idx === currentIndex)}"
          v-for="(c, idx) in sliderContent" :key="idx"
          v-on:click="goToSlide(idx)">
          <div class="pagerImg" :style="{ 'background-image': `url(${c.media.imageLg})` }"></div>
        </div>
      </div>
    </div>
    <div :class="{section2: true, scrolled: scrolled2}">
      <div class="container">
        <h4 class="sectionTitle sm">Pelajari Lebih Jauh dan Mulai Beraksi!</h4>
        <div class="section2Cnt">
          <div class="section2Item s2a">
            <div class="itemImg"><div class="theImg"></div></div>
            <h4>Bumi Kini</h4>
            <p>Mengenal dan memahami kondisi bumi saat ini, di bawah ancaman krisis iklim.</p>
          </div>
          <div class="section2Item s2b">
            <div class="itemImg"><div class="theImg"></div></div>
            <h4>Bicara Bumi</h4>
            <p>Membahas lebih jauh permasalahan krisis iklim melalui pembaharuan informasi,
              wawasan, dan analisis.</p>
          </div>
          <div class="section2Item s2c">
            <div class="itemImg"><div class="theImg"></div></div>
            <h4>Sumber dan Materi</h4>
            <p>Menyajikan sumber dan materi bermanfaat guna meningkatkan pengetahuan seputar
              krisis iklim.</p>
          </div>
          <div class="section2Item s2d">
            <div class="itemImg"><div class="theImg"></div></div>
            <h4>Jejaring</h4>
            <p>Menghubungkan berbagai bentuk gerakan demi bumi yang lebih baik.</p>
          </div>
          <div class="section2Item s2e">
            <div class="itemImg"><div class="theImg"></div></div>
            <h4>Beraksi</h4>
            <p>Mulai wujudkan berbagai bentuk aksimu bagi bumi.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="divider2"></div>
    <div class="section3" ref="section3">
      <div class="section3Bg" :style="{position: sc3Pos}">
        <div class="theBg"></div>
        <div class="bgDonut" :style="{width: donutSize, height: donutSize, top: donutOffset}"></div>
      </div>
      <div class="section3Cnt" :style="{position: sc3Pos}">
        <div :class="{mulaiBeraksi: true, scrolled: scrolled3}">
          <h3>Ayo Beraksi untuk Bumi!</h3>
          <p>Bumi butuh aksimu sekarang! Bersama kita masih punya waktu dan harapan untuk
            mencegah berbagai ancaman yang lebih buruk, demi keberlangsungan masa depan bumi
            dan kehidupan kita.</p>
          <div class="btn">
            <div class="btnL"></div>
            <div class="btnL2"></div>
            <span>Mulai Beraksi</span>
          </div>
        </div>
      </div>
    </div>
    <div class="divider3"></div>
    <div :class="{section2: true, scrolled: scrolled4, section4: true}" ref="section4">
      <div class="container">
        <h4 class="sectionTitle sm">Ikuti #BumiButuhAksi</h4>
        <div class="section2Cnt">
          <div class="section2Item s4a">
            <div class="itemImg"><div class="theImg"></div></div>
            <h4>Greta Thunberg: Berapa Lama Lagi?</h4>
          </div>
          <div class="section2Item s4b">
            <div class="itemImg"><div class="theImg"></div></div>
            <h4>Rekomendasi Buku-Buku Krisis Iklim</h4>
          </div>
          <div class="section2Item s4c">
            <div class="itemImg"><div class="theImg"></div></div>
            <h4>Apa Itu NDC?</h4>
          </div>
          <div class="section2Item s4d">
            <div class="itemImg"><div class="theImg"></div></div>
            <h4>#itstrickychallenge</h4>
          </div>
          <div class="section2Item s4e">
            <div class="itemImg"><div class="theImg"></div></div>
            <h4>Sains Jangan Dianggap Sans</h4>
          </div>
        </div>
      </div>
    </div>
    <div class="divider2"></div>
    <div class="beforeFooter"></div>
  </section>
</template>

<script>
// import img1 from '@/assets/homepage-3.jpg';
// import img2 from '@/assets/homepage-2.jpg';
// import img3 from '@/assets/Mengemas-Pesan-Iklim.jpg';
// import img4 from '@/assets/homepage-5.jpg';
// import img5 from '@/assets/homepage-6.jpg';
// import img6 from '@/assets/homepage-7.jpg';
// import img7 from '@/assets/tenggelam-dalam-diam-cover2.jpg';
import bumiKini from '@/assets/bumi-kini.jpg';
import bicaraBumi from '@/assets/bicara-bumi.jpg';
import beraksi from '@/assets/beraksi.jpg';

export default {
  name: 'home',
  components: {
  },
  data() {
    return {
      // images: [img4, img7, img3],
      sliderContent: [],
      timer: null,
      currentIndex: 0,
      pageActive: 2,
      bumiKini,
      bicaraBumi,
      beraksi,
      menuOpen: false,
      menuAnimate: false,
      scrolled: false,
      scrolled2: false,
      scrolled3: false,
      scrolled4: false,
      socialMedia: [],
      donutOffset: '20vh',
      donutSize: '18vw',
      s3Offset: '0px',
      sc3Pos: 'absolute',
      showSubmenu: false,
      showSubmenu2: false,
      showMenu: false,
    };
  },
  computed: {
    currentImg() {
      return (this.sliderContent[this.currentIndex])
        ? this.sliderContent[this.currentIndex].media.imageLg
        : '';
    },
  },
  created() {
    window.addEventListener('scroll', this.onScrolled);
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScrolled);
  },
  methods: {
    doNothing() {},
    accountSetting() {},
    pesanKreasi() {},
    signOut() {
      this.$session.destroy();
      window.location.reload();
    },
    btnClicked(item, i) {
      if (i === 0) {
        document.body.scrollTop = window.innerHeight;
        document.documentElement.scrollTop = window.innerHeight;
      } else if (item.buttonUrl) {
        // window.location.href = item.buttonUrl;
        this.$router.push(item.buttonUrl);
      }
    },
    toggleMenu() {
      if (this.menuOpen) {
        this.menuAnimate = false;
        setTimeout(() => {
          this.menuOpen = false;
        }, 300);
      } else {
        this.menuOpen = true;
        setTimeout(() => {
          this.menuAnimate = true;
        }, 10);
      }
    },
    next() {
      clearTimeout(this.timer);
      this.currentIndex = (this.currentIndex >= this.sliderContent.length - 1)
        ? 0 : this.currentIndex + 1;
      this.timer = setTimeout(this.next, 8000);
    },
    prev() {
      clearTimeout(this.timer);
      this.currentIndex = (this.currentIndex > 0)
        ? this.currentIndex - 1 : this.sliderContent.length - 1;
      this.timer = setTimeout(this.next, 8000);
    },
    goToSlide(idx) {
      clearTimeout(this.timer);
      this.currentIndex = idx;
      this.startSlide();
    },
    mouseOver(idx) {
      this.pageActive = idx;
    },
    onScrolled(e) {
      this.scrolled = (window.pageYOffset > 100);
      this.scrolled2 = (window.pageYOffset > window.innerHeight * 0.6);
      const earthOffTop = this.$refs.section3.offsetTop;
      const defDonOffTop = window.innerHeight * 20 / 100;
      const defDonSize = window.innerWidth * 18 / 100;
      const sx = window.pageYOffset - earthOffTop;
      const tx = -((sx / 2) - defDonOffTop);
      const ds = sx + defDonSize;
      this.sc3Pos = (sx >= 0) ? 'fixed' : 'absolute';
      this.s3Offset = (sx >= 0) ? `${sx}px` : '0px';
      if (ds < defDonSize) this.donutSize = `${defDonSize}px`;
      else if (ds > 10000) this.donutSize = '10000px';
      else this.donutSize = `${ds}px`;
      if (tx > defDonOffTop) this.donutOffset = `${defDonOffTop}px`;
      else if (tx < -5000) this.donutOffset = '-5000px';
      else this.donutOffset = `${tx}px`;
      this.scrolled3 = (sx > window.innerWidth * 0.6);
      this.scrolled4 = (sx > window.innerHeight * 2);
    },
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = 'Bumi Butuh Aksi';
    this.$http.get(this.$config.uri('slider/all')).then((r) => {
      this.sliderContent = (r.data.status === 200) ? r.data.data : [];
    });
    // const slider1Cnt = 'Sebuah seruan untuk menyatukan aksi memukul mundur krisis iklim '
    //   + 'yang semakin mengancam bumi. Mulai aksimu dengan kenali krisis iklim lebih jauh, '
    //   + 'suarakan kepedulianmu, dan bertindak bersama untuk mencapai solusi,
    // sebab #bumibutuhaksi';
    // this.sliderContent.push({
    //   id: 1,
    //   title: 'Bumi Butuh Aksi',
    //   content: slider1Cnt,
    //   btnLabel: 'Selengkapnya',
    // });
    // const slider2Cnt = 'Menyaksikan bagaimana krisis iklim kian menyapu kehidupan masyarakat '
    //   + 'di wilayah pesisir pantai utara Jawa.';
    // this.sliderContent.push({
    //   id: 2,
    //   title: 'Mengabarkan Kita Tenggelam',
    //   content: slider2Cnt,
    //   btnLabel: 'Telusuri',
    //   btnUri: '/beraksi/tenggelam-dalam-diam',
    // });
    // const slider3Cnt = 'Sebuah wadah interaktif yang mengasah para pemuda kreatif dalam '
    //   + 'menyampaikan pesan-pesan penting krisis iklim melalui beragam
    // kemampuan dalam berkarya.';
    // this.sliderContent.push({
    //   id: 3,
    //   title: 'Mengemas Pesan Iklim Dengan Karya',
    //   content: slider3Cnt,
    //   btnLabel: 'Selengkapnya',
    //   btnUri: '/beraksi/tenggelam-dalam-diam/pelatihan',
    // });
    this.$http.get(this.$config.uri('article/all?parent=social-media'))
      .then((response) => {
        this.socialMedia = (response.data.status === 200) ? response.data.data : [];
        // this.loading = false;
      });
    this.timer = setTimeout(this.next, 5000);
  },
};
</script>

<style scoped lang="scss">
.userPict{
  position: relative;
  margin: 0 20px;
  .headerPict{
    cursor: pointer;
    width: 40px; height: 40px;
    border-radius: 50%;
    font-size: 18px;
    font-weight: normal;
    text-transform: uppercase;
    background-color: #620509;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    background-position: center;
    background-size: cover;
    &.hasPhoto{
      span{
        display: none;
      }
    }
    @media (max-width: 760px) {
      height: 34px; width: 34px;
      font-size: 16px;
    }
  }
  .userMenuOverlay{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
  }
  .userMenu{
    position: absolute;
    background-color: #fff;
    padding: 20px 0 10px;
    color: #444;
    right: -5px; top: 46px;
    box-shadow: 2px 2px 5px rgba(0,0,0,.4);
    width: 320px;
    box-sizing: border-box;
    text-transform: none;
    margin-top: 6px;
    border-radius: 10px;
    .pictCnt{
      display: flex;
      justify-content: center;
      margin-bottom: 10px;
      .thePict{
        width: 80px; height: 80px;
        border-radius: 50%;
        color: #fff;
        background-color: #620509;
        font-size: 38px;
        text-transform: uppercase;
        display: flex;
        align-items: center;
        justify-content: center;
        background-size: cover;
        background-position: center;
        &.hasPhoto{
          span{
            display: none;
          }
        }
      }
    }
    h4, h5{
      margin: 0 20px;
      font-size: 20px;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    h5{
      font-size: 15px;
      font-weight: normal;
      color: #767676;
      margin-bottom: 20px;
    }
    li{
      list-style: none;
      padding: 10px 30px;
      cursor: pointer;
      .bl{
        float: right;
      }
      &:hover{
        background-color: #f5f5fe;
      }
      @media (max-width: 760px) {
        font-weight: 500;
        font-size: 18px;
        padding: 10px 20px;
      }
    }
    .divider{
      border-bottom: #eee 1px solid;
      margin-top: 10px;
      margin-bottom: 10px;
    }
    @media (max-width: 760px) {
      right: -54px;
      margin-top: 0;
    }
  }
}

.loginBtn{
  background-color: #31c1f4;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  margin-left: 20px;
  margin-right: 20px;
  color: #fff;
  font-weight: 700;
  border-radius: 3px;
  box-shadow: 2px 2px 2px rgba(0,0,0,.1);
  cursor: pointer;
  transition: all .3s ease;
  @media (max-width: 768px) {
    display: none;
  }
  &:hover{
    background-color: #1eb0e4;
  }
}
.beforeFooter{
  height: 40px;
  background-color: #fff;
  position: relative;
  z-index: 9;
  @media (max-width: 680px) {
    height: 0;
  }
}
.section2.section4{
  padding: 100px 0;
  overflow: hidden;
  z-index: 99;
  @media (max-width: 680px) {
    padding: 40px 0 0;
  }
  .sectionTitle{
    font-size: 70px;
    transform: translateY(100px);
    white-space: nowrap;
    @media (max-width: 680px) {
      // transform: none;
      font-size: 26px;
    }
  }
  .container{
    .section2Cnt{
      .section2Item{
        h4{
          font-size: 20px;
        }
      }
    }
  }
  .s4a{
    transform: translate(-140px, 120px);
    .itemImg .theImg{
      background-image: url(../assets/s4a.jpg);
    }
  }
  .s4b{
    transform: translate(-60px, 120px);
    .itemImg .theImg{
      background-image: url(../assets/s4b.jpg);
    }
  }
  .s4c{
    transform: translate(0, 120px);
    .itemImg .theImg{
      background-image: url(../assets/s4c.jpg);
    }
  }
  .s4d{
    transform: translate(60px, 120px);
    .itemImg .theImg{
      background-image: url(../assets/s4d.jpg);
    }
  }
  .s4e{
    transform: translate(140px, 120px);
    .itemImg .theImg{
      background-image: url(../assets/s4e.jpg);
    }
  }
  &.scrolled{
    .sectionTitle{
      font-size: 68px;
      @media (max-width: 1024px) {
        font-size: 56px;
      }
      @media (max-width: 680px) {
        font-size: 26px;
      }
    }
    .s4a, .s4b, .s4c, .s4d, .s4e{
      transform: translate(0, 0);
    }
  }
}
.divider3{
  height: 100px;
  background-image: url(../assets/divider-bg.png);
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: bottom center;
  margin-top: -96px;
  margin-bottom: -2px;
  position: relative;
  z-index: 4;
}
.section3{
  position: relative;
  overflow: hidden;
  height: 260vh;
  .section3Bg{
    height: 100vh;
    position: absolute;
    top: 0; left: 0; right: 0;
    .theBg{
      position: absolute;
      left: 0; top: 0; right: 0; bottom: 0;
      background-image: url(../assets/aksi-bumi.jpg);
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }
    .bgDonut{
      margin-top: -1000px;
      border: #fff 1000px solid;
      width: 18vw; height: 18vw;
      border-radius: 50%;
      position: absolute;
      left: 50%; top: 20vh;
      transform: translateX(-50%);
    }
  }
  .section3Cnt{
    position: absolute;
    left: 0; right: 0; top: 0;
    z-index: 3;
    height: 100vh;
    .mulaiBeraksi{
      position: relative;
      z-index: 999;
      text-align: center;
      width: 840px;
      color: #444;
      transition: all .4s ease;
      margin: 0 auto;
      padding-top: 56vh;
      @media (max-width: 960px) {
        width: 100%;
        padding-left: 16px;
        padding-right: 16px;
        box-sizing: border-box;
      }
      @media (max-width: 680px) {
        padding-top: 38vh;
      }
      h3{
        margin: 0 0 20px;
        line-height: 1;
        font-size: 56px;
        transition: all .4s ease;
        font-weight: 800;
        @media (max-width: 960px) {
          font-size: 46px;
          margin-bottom: 6px;
        }
        @media (max-width: 680px) {
          font-size: 36px;
          line-height: 1.2;
        }
      }
      p{
        font-size: 20px;
        margin: 0 0 20px;
        line-height: 1.5;
        font-weight: lighter;
        opacity: 0;
        transition: all .4s ease;
        @media (max-width: 680px) {
          font-size: 16px;
          line-height: 1.3;
        }
      }
      .btn{
        background: #fff;
        border-radius: 50px;
        color: #000;
        box-shadow: none;
        font-weight: lighter;
        padding: 4px 16px;
        font-size: 14px;
        padding-left: 36px;
        position: relative;
        transition: all .4s ease;
        cursor: pointer;
        opacity: 0;
        font-weight: 600;
        span{
          position: relative;
          z-index: 2;
        }
        .btnL{
          width: 25px; height: 25px;
          border-radius: 50px;
          background-color: #000;
          position: absolute;
          left: 1px; top: 1px;
          transition: all .3s ease;
          background-image: url(../assets/right-arrow-notail-white.png);
          background-size: 13px auto;
          background-position: 7px 50%;
          background-repeat: no-repeat;
        }
        .btnL2{
          width: 25px; height: 25px;
          border-radius: 50px;
          position: absolute;
          left: 1px; top: 1px;
          transition: all .3s ease;
          background-image: url(../assets/right-arrow-notail-white.png);
          background-size: 13px auto;
          background-position: 7px 50%;
          background-repeat: no-repeat;
        }
        &:hover{
          color: #fff;
          .btnL{
            width: calc(100% - 2px);
          }
          .btnL2{
            left: 10px;
          }
        }
      }
      &.scrolled{
        color: #fff;
        padding-top: 42vh;
        p, .btn{
          opacity: 1;
        }
      }
    }
  }
}
.section2{
  background-color: #f4f6f1;
  padding: 20vh 0 120px;
  position: relative;
  z-index: 2;
  @media (max-width: 960px) {
    padding-bottom: 60px;
  }
  .sectionTitle{
    font-size: 52px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 40px;
    transform: translateY(180px);
    opacity: 0;
    transition: all .9s ease;
    font-weight: 800;
    @media (max-width: 1280px) {
      font-size: 46px;
    }
    @media (max-width: 960px) {
      font-size: 30px;
    }
    @media (max-width: 680px) {
      font-size: 26px;
    }
  }
  .container{
    max-width: 1200px;
    margin: 0 auto;
    @media (max-width: 1280px) {
      max-width: none;
      margin: 0 20px;
    }
    .section2Cnt{
      display: flex;
      flex-wrap: wrap;
      margin: 0 -6px;
      @media (max-width: 680px) {
        display: block;
      }
      .section2Item{
        width: calc(20% - 12px);
        margin: 0 6px;
        transition: all .9s ease;
        opacity: 0;
        @media (max-width: 960px) {
          width: calc(33.333333% - 12px);
          margin-bottom: 30px;
        }
        @media (max-width: 680px) {
          transform: none !important;
          width: auto;
          margin: 0 0 60px;
        }
        .itemImg{
          height: 240px;
          position: relative;
          overflow: hidden;
          cursor: pointer;
          @media (max-width: 1280px) {
            height: 18vw;
          }
          @media (max-width: 680px) {
            height: 80vw;
          }
          .theImg{
            position: absolute;
            left: 0; right: 0; top: 0; bottom: 0;
            transition: all .3s ease;
            background-position: center;
            background-size: cover;
            background-color: #ddd;
          }
        }
        h4{
          font-size: 24px;
          margin: 10px 0 14px;
          font-weight: 800;
        }
        p{
          margin: 0;
          color: #767676;
        }
      }
      @media (max-width: 1280px) {
      }
      @media (max-width: 768px) {
      }
    }
  }
  .s2a{
    .itemImg .theImg{
      &:hover{
        transform: scale(1.2);
      }
      background-image: url(../assets/s2a.jpg);
    }
  }
  .s2b{
    transform: translateY(10px);
    .itemImg .theImg{
      &:hover{
        transform: scale(1.2);
      }
      background-image: url(../assets/s2b.jpg);
    }
  }
  .s2c{
    .itemImg .theImg{
      &:hover{
        transform: scale(1.2);
      }
      background-image: url(../assets/s2c.jpg);
    }
  }
  .s2d{
    .itemImg .theImg{
      &:hover{
        transform: scale(1.2);
      }
      background-image: url(../assets/s2d.jpg);
    }
  }
  .s2e{
    .itemImg .theImg{
      &:hover{
        transform: scale(1.2);
      }
      background-image: url(../assets/s2e.jpg);
    }
  }
  &.scrolled{
    .sectionTitle{
      transform: translateY(0);
      opacity: 1;
    }
    .container{
      .section2Cnt{
        .section2Item{
          opacity: 1;
        }
      }
    }
    .s2a{
      transform: translateY(60px);
    }
    .s2b{
      transform: translateY(0);
    }
    .s2c{
      transform: translateY(80px);
    }
    .s2d{
      transform: translateY(140px);
      @media (max-width: 960px) {
        transform: translateY(60px);
      }
    }
    .s2e{
      transform: translateY(20px);
    }
  }
}
.divider2{
  height: 100px;
  background-image: url(../assets/divider2.png);
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: bottom center;
  position: relative;
  z-index: 3;
  margin-top: -2px;
  margin-bottom: -2px;
  background-color: #fff;
}
.section.sm{
  padding-bottom: 0;
}
.sectionTitle.sm{
  @media (max-width: 760px) {
    text-align: center;
  }
}
.socialMediaCnt{
  margin: 20px -10px 40px;
  .item{
    width: 25%;
    @media (max-width: 990px) {
      width: 33.333%;
    }
    @media (max-width: 760px) {
      width: 100%;
    }
    .smItemCnt{
      padding: 0 10px 20px;
    }
    .smItem{
      border-radius: 0px;
      overflow: hidden;
      line-height: 1;
      box-shadow: 2px 2px 3px rgba(0,0,0,.1);
      cursor: pointer;
      transition: all .2s ease;
      position: relative;
      @media (max-width: 760px) {
        border-radius: 10px;
      }
      .smOverlay{
        display: block;
        text-decoration: none;
        position: absolute;
        left: 0; right: 0; top: 0; bottom: 0;
        background-color: rgba(0,0,0,.7);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2;
        font-weight: bold;
        font-size: 18px;
        opacity: 0;
        transition: all .2s ease;
        .ov-x{
          text-align: center;
          img{
            display: block;
            width: 40px;
            margin: 0 auto 14px;
          }
        }
      }
      &:hover{
        transform: scale(1.02);
        box-shadow: 4px 4px 0 #31c1f4;
        .smOverlay{
          opacity: 1;
        }
      }
      img{
        width: 100%;
      }
      .smInfo{
        margin-top: -2px;
        padding: 12px 16px;
        font-weight: bold;
        background-color: #fff;
        min-height: 46px;
        box-sizing: border-box;
        position: relative;
        padding-right: 60px;
        line-height: 1.4;
        .smIcon{
          width: 26px;
          height: 26px;
          position: absolute;
          right: 16px;
          top: 10px;
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          &.tiktok{
            background-image: url(../assets/i-tiktok.svg);
          }
          &.instagram{
            background-image: url(../assets/i-instagram.png);
          }
          &.youtube{
            background-image: url(../assets/i-youtube.png);
          }
        }
      }
    }
  }
}

header{
  position: fixed;
  top: 0; left: 0; right: 0;
  z-index: 999;
  .headerBg{
    background-color: #fff;
    position: absolute; right: 0; left: 0; top: 0; height: 0px;
    transition: all .3s ease;
  }
  &.scrolled{
    .headerBg{
      height: 80px;
      @media (max-width: 768px) {
        height: 64px;
      }
    }
    .logoLink{
      height: 80px; width: 80px;
      .logo{
        height: 80px; width: 80px;
        top: 0px; left: 15px;
        opacity: 1;
        &.white{
          opacity: 0;
        }
      }
      @media (max-width: 768px) {
        width: 64px; height: 64px;
        .logo{
          width: 64px; height: 64px;
          left: 0;
        }
      }
    }
    .menuToggle{
      background-image: url(../assets/menu.png);
    }
    .menu{
      .menuItem{
        color: #444;
        &:hover{
          color: #444;
          border-color: #ccc;
        }
      }
    }
  }
  &.menuOpen{
    z-index: 14;
    .menu{
      @media (max-width: 768px) {
        display: block;
      }
    }
    .menuOverlay{
      display: block;
    }
  }
  &.menuAnimate{
    .menu{
      right: 0;
      opacity: 1;
    }
    .menuOverlay{
      opacity: .5;
    }
  }
  .container{
    position: relative;
    max-width: 1600px;
    margin: 0 auto;
  }
  .logoLink{
    width: 110px;
    height: 110px;
    display: block;
    margin-left: 14px;
    position: relative;
    .logo{
      width: 110px;
      height: 110px;
      background-image: url(../assets/logo.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      transition: all .4s ease;
      position: absolute;
      left: 0; top: -10px;
      opacity: 0;
      &.white{
        background-image: url(../assets/logo-white.png);
        opacity: 1;
      }
    }
    @media (max-width: 1100px) {
      margin-left: 10px;
    }
    @media (max-width: 768px) {
      margin-left: 4px;
      width: 96px; height: 96px;
      .logo{
        width: 96px; height: 96px;
      }
    }
  }
  .userPict{
    @media (max-width: 768px) {
      display: none;
    }
  }
  .loginForMobile{
    display: none;
    position: absolute;
    right: 48px; top: 15px;
    @media (max-width: 768px) {
      .userMenu{
        padding-top: 10px;
        .pictAndName{
          position: relative;
          padding-left: 60px;
          h5, h4{
            text-align: left;
          }
          h4{
            font-size: 18px;
          }
          h5{
            margin-top: -3px;
          }
          .pictCnt{
            .thePict{
              position: absolute;
              left: 20px; top: 6px;
              width: 46px; height: 46px;
              font-size: 20px;
            }
          }
        }
      }
      display: block;
      .userPict{
        display: block;
        .headerPict{
          font-size: 13px;
        }
      }
      .loginBtn{
        display: block;
        margin-top: -3px;
        margin-right: 26px;
      }
    }
  }
  .menuToggle{
    display: none;
    @media (max-width: 768px) {
      transition: all .2s ease;
      display: block;
      width: 50px; height: 50px;
      border-radius: 50%;
      position: absolute;
      right: 14px; top: 7px;
      z-index: 3;
      background-image: url(../assets/menu-white.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: 1;
    }
  }
  .menuOverlay{
    display: none;
    @media(max-width: 768px){
      display: block;
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: #000;
      opacity: 0;
      display: none;
      transition: all .3s ease;
    }
  }
  .menu{
    position: absolute;
    top: 20px; bottom: 7px; right: 14px;
    display: flex;
    transition: all .3s ease;
    .menuItem{
      cursor: pointer;
      display: block;
      height: 36px;
      line-height: 36px;
      padding: 0 14px;
      margin: 0 2px;
      text-decoration: none;
      color: #fff;
      font-size: 16px;
      transition: all .3s ease;
      border-bottom: transparent 2px solid;
      position: relative;
      &:hover{
        color: #fff;
        border-color: #fff;
      }
      @media (max-width: 768px) {
        color: #444 !important;
        height: auto;
        border-left: transparent 2px solid;
        border-bottom: none;
        margin-bottom: 10px !important;
        &.hasSubmenu{
          &:before{
            content: "";
            position: absolute;
            right: 8px; top: 0;
            width: 20px; height: 38px;
            background-image: url(../assets/arrow-down-bold.png);
            background-size: 16px auto;
            background-position: center;
            background-repeat: no-repeat;
            opacity: .5;
          }
        }
      }
      .submenuOverlay{
        background-color: rgba(0,0,0,.3);
        position: fixed;
        z-index: 7;
        left: 0; top: 0; right: 0; bottom: 0;
        @media (max-width: 768px) {
          display: none !important;
        }
      }
      .submenu{
        position: absolute;
        z-index: 9;
        background-color: #fff;
        padding: 10px 0;
        left: -6px; top: 100%;
        margin-top: -2px;
        border-radius: 5px;
        box-shadow: 2px 2px 4px rgba(0,0,0,.2);
        overflow: hidden;
        @media (max-width: 768px) {
          display: block;
          position: static;
          box-shadow: none;
          margin: 6px 0 0;
          background-color: rgba(0, 0, 0, .1);
        }
        a{
          display: block;
          text-decoration: none;
          color: #444;
          padding: 4px 20px;
          white-space: nowrap;
          font-size: 15px;
          &:hover{
            background-color: #f5f5fe;
          }
        }
      }
    }
    .closeMenu{
      display: none;
    }
    .menuHome{
      display: none;
    }
    @media (max-width: 768px) {
      position: fixed;
      top: 0; right: -300px; bottom: 0;
      opacity: 0;
      background-color: #fff;
      display: none;
      transition: all .3s ease;
      padding: 40px 20px 0;
      min-width: 300px;
      z-index: 12;
      .menuItem{
        margin-bottom: 20px;
      }
      .menuHome{
        display: block;
      }
      .closeMenu{
        display: block;
        width: 50px; height: 50px;
        border-radius: 50%;
        position: absolute;
        right: 14px; top: 7px;
        background-image: url(../assets/close.png);
        background-size: 16px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .8;
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 1.9s ease;
  overflow: hidden;
  visibility: visible;
  position: absolute;
  width:100%;
  opacity: 1;
}
.fade-enter,
.fade-leave-to {
  visibility: hidden;
  width:100%;
  opacity: 0;
}

.welcomePaging{
  position: absolute;
  max-width: 1600px;
  margin: 0 auto;
  width: 100%;
  z-index: 999;
  .pItem{
    position: absolute;
    top: 50%;
    width: 40px; height: 40px;
    border: #fff 2px solid;
    border-radius: 50px;
    margin-top: -20px;
    background-size: 22px auto;
    background-position: center;
    background-repeat: no-repeat;
    transition: all .3s ease;
    cursor: pointer;
    opacity: .8;
    &:hover{
      width: 60px;
      opacity: 1;
    }
    &.pLeft{
      left: 30px;
      background-image: url(../assets/arrow-left-white.png);
      @media (max-width: 960px) {
        left: 14px;
      }
    }
    &.pRight{
      right: 30px;
      background-image: url(../assets/arrow-right-white.png);
      @media (max-width: 960px) {
        right: 14px;
      }
    }
  }
  @media (max-width: 680px) {
    display: flex;
    width: auto;
    right: 12px;
    bottom: 8px;
    .pItem{
      position: static;
      width: 30px; height: 30px;
      background-size: 17px auto;
      &.pRight{
        margin-left: 10px;
      }
    }
  }
}
.welcomePager{
  position: absolute;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 20px; bottom: 20px;
  @media (max-width: 680px) {
    left: 50%; right: auto;
    transform: translateX(-50%);
  }
  .pager{
    width: 30px;
    height: 5px;
    background-color: rgba(255,255,255,.4);
    margin: 0 2px;
    cursor: pointer;
    transition: all .2s ease;
    position: relative;
    .pagerImg{
      position: absolute;
      width: 20px; height: 20px;
      background-size: cover;
      background-position: center;
      opacity: 0;
      transition: all .2s ease;
      top: 50%; left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 50%;
    }
    &.active{
      background-color: #fff;
    }
    &:hover{
      transform: scale(2);
      background-color: transparent;
      .pagerImg{
        opacity: 1;
      }
    }
  }
}

.bgDivider{
  height: 100px;
  position: absolute;
  left: 0; right: 0; bottom: -4px;
  background-image: url(../assets/divider-bg.png);
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: bottom center;
}

.welcomeBg{
  position: absolute;
  left: 0; right: 0; top: 0; height: 110vh;
  z-index: 4;
  .sliderCnt{
    position: absolute;
    left: 0; top: 0;
    width: 100%; height: 100%;
    .sliderItem{
      background-size: cover;
      background-position: center;
      height: 110vh;
      &:before{
        display: block;
        content: "";
        position: absolute;
        left: 0; right: 0; top: 0; bottom: 0;
        background-color: rgba(0,0,0,.2);
      }
      &.img1:before{
        background-color: rgba(0,0,0,.3);
      }
      &.img2:before{
        background-color: rgba(0,0,0,.1);
      }
      &.img3:before{
        background-color: rgba(0,0,0,.4);
      }
      &.img4:before{
        background-color: rgba(0,0,0,.2);
      }
      &.img5:before{
        background-color: rgba(0,0,0,.2);
      }
      &.img6:before{
        background-color: rgba(0,0,0,.2);
      }
    }
  }
}
.section{
  max-width: 1240px;
  margin: 0 auto;
  padding: 60px 0;
}
.welcome{
  position: relative;
  z-index: 5;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .welcomeCnt{
    position: relative;
    z-index: 999;
    text-align: center;
    width: 760px;
    color: #fff;
    display: none;
    transition: all .3s ease;
    animation: animateBoss 0.5s ease both;
    @media (max-width: 960px) {
      width: 100%;
      padding: 0 80px;
    }
    @media (max-width: 680px) {
      padding: 0 16px;
    }
    @keyframes animateBoss {
      0% {
        transform: translateY(100px);
        opacity: 0;
      }
      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }
    &.active{
      display: block;
    }
    h2{
      font-size: 160px;
      margin: 0 0 20px;
      line-height: 1;
      text-transform: uppercase;
      font-size: 80px;
      font-weight: 800;
      @media (max-width: 1024px) {
        font-size: 76px;
      }
      @media (max-width: 960px) {
        font-size: 62px;
      }
      @media (max-width: 680px) {
        font-size: 36px;
        line-height: 1.2;
      }
      span{
        display: block;
        font-size: 80%;
      }
    }
    p{
      font-size: 20px;
      margin: 0 0 20px;
      line-height: 1.5;
      font-weight: lighter;
      @media (max-width: 960px) {
        font-size: 18px;
        line-height: 1.3;
      }
      @media (max-width: 680px) {
        font-size: 16px;
      }
    }
    .btn{
      background: #fff;
      border-radius: 50px;
      color: #000;
      box-shadow: none;
      font-weight: 600;
      padding: 4px 16px;
      font-size: 14px;
      padding-left: 36px;
      position: relative;
      transition: all .3s ease;
      cursor: pointer;
      span{
        position: relative;
        z-index: 2;
      }
      .btnL{
        width: 25px; height: 25px;
        border-radius: 50px;
        background-color: #000;
        position: absolute;
        left: 1px; top: 1px;
        transition: all .3s ease;
        background-image: url(../assets/right-arrow-notail-white.png);
        background-size: 13px auto;
        background-position: 7px 50%;
        background-repeat: no-repeat;
      }
      .btnL2{
        width: 25px; height: 25px;
        border-radius: 50px;
        position: absolute;
        left: 1px; top: 1px;
        transition: all .3s ease;
        background-image: url(../assets/right-arrow-notail-white.png);
        background-size: 13px auto;
        background-position: 7px 50%;
        background-repeat: no-repeat;
      }
      &:hover{
        color: #fff;
        .btnL{
          width: calc(100% - 2px);
        }
        .btnL2{
          left: 10px;
        }
      }
    }
  }
}
.pages{
  position: relative;
  z-index: 2;
  .pagesWrapper{
    margin: 0 auto;
    width: 1240px;
    @media (max-width: 990px) {
      overflow-x: auto;
      width: 100%;
      margin: 0 !important;
      padding: 0 0 0 20px;
      box-sizing: border-box;
    }
  }
  .pagesCnt{
    display: flex;
    height: 560px;
    margin: 0 -8px;
    @media (max-width: 990px) {
      width: 1080px;
      height: 340px !important;
    }
    @media (max-width: 760px) {
      width: 900px;
      height: 280px !important;
    }
  }
  .page{
    background-color: #f5f5f5;
    margin: 0 8px;
    width: 22%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    box-sizing: border-box;
    padding: 20px;
    transition: all .3s ease;
    position: relative;
    overflow: hidden;
    .pageBg{
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
      background-size: cover;
      background-position: center;
      opacity: 0;
      transition: all .3s ease;
      z-index: 3;
      &:before{
        display: block;
        content: "";
        position: absolute;
        left: 0; top: 0; right: 0; bottom: 0;
        background-color: #000;
        opacity: .7;
      }
      &.bumiKini:before{
        background: #007991;
        background: -webkit-linear-gradient(to right, #78ffd6, #007991);
        background: linear-gradient(to right, #78ffd6, #007991);
      }
      &.bicaraBumi:before{
        background: #000046;
        background: -webkit-linear-gradient(to right, #1CB5E0, #000046);
        background: linear-gradient(to right, #1CB5E0, #000046);
      }
      &.beraksi:before{
        background: #c0392b;
        background: -webkit-linear-gradient(to right, #8e44ad, #c0392b);
        background: linear-gradient(to right, #8e44ad, #c0392b);
      }
      .pageBgCnt{
        position: absolute;
        left: 50%; top: 50%;
        transform: translate(-50%, -50%);
        z-index: 2;
        width: 438px;
        color: #fff;
        @media (max-width: 990px) {
          width: 100%;
          padding: 0 40px;
          box-sizing: border-box;
          p{
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        @media (max-width: 760px) {
          padding: 0 20px;
        }
        img{
          height: 60px;
          margin-bottom: 6px;
        }
        h4{
          font-size: 36px;
          margin-bottom: 4px;
        }
        p{
          font-size: 20px;
        }
        .btn{
          font-weight: 600;
          // height: 40px;
          // line-height: 40px;
          // padding: 0 16px;
          margin-top: 14px;
          // font-size: 17px;
        }
      }
    }
    .pageCnt{
      position: relative;
      z-index: 2;
      margin: 0 auto;
      max-width: 164px;
      img{
        height: 40px;
        opacity: .7;
        margin-bottom: 4px;
      }
    }
    h4{
      margin: 0 0 10px;
      font-size: 24px;
    }
    p{
      margin: 0;
      font-size: 15px;
    }
    &.active{
      width: 56%;
      color: #fff;
      .pageBg{
        opacity: 1;
      }
    }
    @media (max-width: 990px) {
      width: 340px !important;
      color: #fff;
      .pageBg{
        opacity: 1;
      }
    }
    @media (max-width: 760px) {
      width: 280px !important;
      color: #fff;
      border-radius: 10px;
      .pageBg{
        opacity: 1;
        .pageBgCnt{
          img{
            height: 40px;
          }
          h4{
            font-size: 30px;
          }
          p{
            font-size: 14px;
          }
        }
      }
    }
  }
}
.classCnt{
  padding: 60px 0 0;
  .kelasIklimCnt{
    max-width: 1240px;
    margin: 0 auto;
    display: flex;
    background-color: #f5f5f5;
    position: relative;
    &.kelasIklimHome{
      @media (max-width: 990px) {
        margin: 0 !important;
        display: block;
        padding-top: 40px;
        overflow: hidden;
      }
    }
    .imgL{
      width: 50%;
      height: 600px;
      background-image: url(../assets/kelas-iklim-scr.png);
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      @media (max-width: 990px) {
        width: auto;
        height: 640px !important;
      }
      @media (max-width: 760px) {
        height: 100vw !important;
      }
    }
    .contentR{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50%;
      @media (max-width: 990px) {
        width: auto;
        margin-top: -460px;
        padding: 0 20px 20px;
        &:before{
          display: block;
          content: "";
          position: absolute;
          top: 0; right: 0; left: 0;
          height: 480px;
          background-image: linear-gradient(transparent, #fff);
        }
        &:after{
          display: block;
          content: "";
          position: absolute;
          top: 480px; right: 0; left: 0; bottom: 0;
          background-color: #fff;
        }
      }
      @media (max-width: 760px) {
        margin-top: -70vw;
        &:before{
          height: 72vw;
        }
        &:after{
          top: 72vw;
        }
      }
      .theContent{
        position: relative;
        z-index: 2;
        text-align: center;
        .logoCnt{
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #767676;
          position: absolute;
          right: -250px; top: -120px;
          transform: scale(.4);
          @media (max-width: 990px) {
            position: static;
          }
          .madani, .gp, ._350{
            width: 200px;
            height: 100px;
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
          }
          .madani{
            background-image: url(../assets/thumb__120_25_0_0_auto.png);
            background-size: 130px auto;
            background-position: 50% 10px;
            margin-left: 18px;
          }
          .gp{
            background-image: url(../assets/gp-logo.svg);
            background-size: 200px auto;
            background-position: 50% 36px;
          }
          ._350{
            background-image: url(../assets/350-logo-v3-white.png);
            background-size: 100px auto;
          }
        }
      }
      h4{
        font-size: 80px;
        margin: 0;
      }
      h5{
        margin: 4px 0;
        font-size: 28px;
        color: #31c1f4;
      }
      h3{
        margin: 0 30px;
        font-size: 34px;
        line-height: 1.3;
      }
      .btn{
        margin-top: 20px;
      }
    }
  }
  .classWrapper{
    max-width: 1240px;
    margin: 0 auto;
    background-image: url(../assets/kelas-iklim.jpg);
    background-position: center;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 100px 0;
    display: none;
    &:before{
      display: block;
      content: "";
      position: absolute;
      left: 0; top: 0; right: 0; bottom: 0;
      background-color: #000;
      opacity: 0;
    }
    .classContent{
      position: relative;
      z-index: 2;
      text-align: center;
      color: #fff;
      margin-top: -20px;
      h4{
        margin: 0 0 5px;
        font-size: 80px;
        font-weight: bold;
      }
      h5{
        margin: 0;
        font-size: 50px;
        background-color: #fff;
        color: #00485d;
        display: inline;
        box-decoration-break: clone;
        padding: 0 12px 2px;
      }
      .kelasIklim{
        // padding: 40px 0;
        font-size: 100px;
        font-weight: bold;
        padding-bottom: 20px;
        h4{
          text-transform: uppercase;
          font-size: 60px;
          font-weight: normal;
          letter-spacing: 26px;
          margin: 0 0 -20px;
        }
        h5{
          background: none;
          // font-family: 'Dancing Script', cursive;
          color: #19428a;
          font-size: 200px;
        }
        h6{
          text-transform: uppercase;
          font-size: 60px;
          font-weight: normal;
          margin: -20px 0 0;
          letter-spacing: 10px;
        }
      }
      .nextClassCnt{
        max-width: 600px;
        margin: 30px auto 0;
        h4{
          font-size: 30px;
        }
        h5{
          font-size: 30px;
          background: none;
        }
        .speaker{
          width: 360px;
          text-align: left;
          margin: 20px auto 0;
          position: relative;
          padding-left: 100px;
          box-sizing: border-box;
          .speakerPhoto{
            width: 80px;
            height: 80px;
            position: absolute;
            left: 0; top: 0;
            background-color: #fff;
            border-radius: 50%;
          }
          h4{
            font-size: 22px;
            margin: 0;
          }
          h5{
            font-size: 17px;
            padding: 0;
            margin: 0;
            font-weight: normal;
            color: #fff;
          }
          p{
            margin: 0;
            font-size: 17px;
          }
        }
      }
      .actionCnt{
        margin-top: 40px;
        .btn{
          display: inline-block;
          font-weight: 600;
          background-color: #ff600b;
          height: 40px;
          padding: 0 16px;
          color: #fff;
          border: none;
          border-radius: 3px;
          letter-spacing: .4px;
          margin-top: 14px;
          font-size: 20px;
          cursor: pointer;
          outline: 0;
          margin: 0 5px;
        }
      }
    }
    .logoCnt{
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #767676;
      position: absolute;
      right: -200px; top: 0;
      transform: scale(.4);
      .madani, .gp, ._350{
        width: 200px;
        height: 100px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }
      .madani{
        background-image: url(../assets/thumb__120_25_0_0_auto.png);
        background-size: 130px auto;
        background-position: 50% 10px;
        margin-left: 18px;
      }
      .gp{
        background-image: url(../assets/gp-logo.svg);
        background-size: 200px auto;
        background-position: 50% 36px;
      }
      ._350{
        background-image: url(../assets/350-logo-v3-white.png);
        background-size: 100px auto;
      }
    }
  }
}
</style>
